(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["svs-fr-cart-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('svs-fr-cart-button')) {
    customElements.define('svs-fr-cart-button', class extends HTMLElement {
      // Why click, not submit: Shopify's web pixel manager publishes a product_added_to_cart
      // (a Meta AddToCart with empty product data) from any native submit event on a /cart/add
      // form, then publishes the real one from the fetch. Two ATC per click (found 2026-09-10).
      // A type="button" click never raises a submit event, so only the fetch is counted.
      connectedCallback() {
        this.addEventListener('click', this.onClick);
        this.addEventListener('submit', this.blockSubmit);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('submit', this.blockSubmit);
      }

      blockSubmit = (event) => { event.preventDefault(); };

      onClick = (event) => {
        if (!event.target.closest('[data-svs-fr-add]')) return;
        event.preventDefault();
        this.addBundle();
      };

      addBundle = async () => {
        const section = this.closest('.svs-fr');
        if (section.dataset.cartBusy === 'true') return;
        section.dataset.cartBusy = 'true';
        const buttons = [...section.querySelectorAll('svs-fr-cart-button button:not(:disabled)')];
        buttons.forEach((button) => { button.disabled = true; });
        const form = this.querySelector('form');
        const status = this.querySelector('[role="status"]');
        const label = this.querySelector('[data-cart-label]');
        status.textContent = '';
        label.textContent = 'Adding...';
        form.setAttribute('aria-busy', 'true');
        let added = false;
        try {
          const { CartAddEvent } = await import('@theme/events');
          const data = new FormData(form);
          const sections = [...document.querySelectorAll('cart-items-component[data-section-id]')]
            .map((element) => element.dataset.sectionId);
          data.set('sections', [...new Set(sections)].join(','));
          data.set('sections_url', window.location.pathname);
          const response = await fetch(Theme.routes.cart_add_url, {
            method: 'POST', body: data, headers: { Accept: 'application/json' }
          });
          const result = await response.json();
          if (!response.ok || result.status) {
            status.textContent = result.description || result.message || 'Unable to add this collection. Please try again.';
            return;
          }
          added = true;
          let cart;
          try {
            const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
            if (cartResponse.ok) cart = await cartResponse.json();
          } catch {}
          this.dispatchEvent(new CartAddEvent(cart, data.get('id'), {
            source: 'product-form-component', productId: this.dataset.productId,
            itemCount: 1, sections: result.sections
          }));
          status.textContent = 'Collection added to your cart.';
          document.querySelector('cart-drawer-component')?.showDialog?.();
        } catch {
          status.textContent = added
            ? 'Collection added. Open your cart to view it.'
            : 'We could not confirm the cart update. Check your cart before trying again.';
        } finally {
          section.dataset.cartBusy = 'false';
          buttons.forEach((button) => { button.disabled = false; });
          label.textContent = 'Add to Cart';
          form.removeAttribute('aria-busy');
        }
      };
    });
  }
  } catch(e) { console.error(e); }
})();

})();
